const TRANSACTION_HISTORY_METHOD_ENUM = {
    WEB: 'web',
    API: 'api',
    APPLICATION: 'application',
    INVOICE: 'invoice',
    PRE_CHECKOUT: 'pre_checkout',
};

export default TRANSACTION_HISTORY_METHOD_ENUM;